import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useFormik } from "formik";
import Select from "react-select";
import Breadcrumbs from "components/Common/Breadcrumb";
import { exportEmployeeToExcel } from "pages/exports/exportExcel";
import { exportEmployeeToPDF } from "pages/exports/exportPDF";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainer from "components/Common/TableContainer";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchTimesheetReportDropdowns, fetchTimesheetReportList, resetTimesheetEmployeeTaskStatusReport } from "store/actions";
import CustomSelect from "components/Common/custom-select";
import * as Yup from "yup";
import { getAttendanceSalaryDate } from "common/attendanceSalaryDate";

const TimesheetReportEmployeeDayWise = () => {
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prev) => !prev);
  const {
    reportDropdowns,
    reportList,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    reportDropdowns: state.TimesheetReportsReducer?.reportDropdowns ?? [],
    reportList: state.TimesheetReportsReducer?.reportList ?? [],

    loading: state.TimesheetReportsReducer?.loading,
    error: state.TimesheetReportsReducer?.error,
    success: state.TimesheetReportsReducer?.success
  }));
  const { client_list, project_list, time_tasktype, time_tasknatures, time_taskstatus, appStatus_list } = reportDropdowns;



  useEffect(() => {
    if (authDetails) {
      getAttendanceSalaryDate(authDetails.unit_id).then(response => {
        if (response.status === "success" && response.data.length > 0) {
          const data = response.data[0];
          formik.setFieldValue("fromDate", data.from_date.split('/').reverse().join('-'));
          formik.setFieldValue("toDate", data.to_date.split('/').reverse().join('-'));
        }
      });
    }
  }, [authDetails]);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    const formData = new FormData();
    formData.append("unit_id", unitId)
    formData.append("create_by", authUserDetails[0].user_id)
    dispatch(fetchTimesheetReportDropdowns(formData));
  }, [dispatch]);

  useEffect(() => {
    dispatch(resetTimesheetEmployeeTaskStatusReport());
  }, [])

  const formik = useFormik({
    initialValues: {
      fromDate: "",
      toDate: "",
      project: "",
      client: "",
      taskType: "",
      taskNature: "",
      status: "",
      appStatus: "",
    },
    validationSchema: Yup.object({
      fromDate: Yup.date().nullable()
        .required("From Date is required"),

      toDate: Yup.date().nullable()
        .required("To Date is required")
        .test(
          "is-after-fromDate",
          "To Date cannot be before From Date",
          function (value) {
            const { fromDate } = this.parent;
            if (!fromDate || !value) return true;
            return new Date(value) >= new Date(fromDate);
          }
        )
    }),
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("from_date", values.fromDate || "");
      formData.append("to_date", values.toDate || "");
      formData.append("project_id", values.project && values.project.length ? values.project.map(item => item.value).join(",") : '0');
      formData.append("client_id", values.client && values.client.length ? values.client.map(item => item.value).join(",") : '0');
      formData.append("task_type_id", values.taskType?.value || '0');
      formData.append("task_nature_id", values.taskNature?.value || '0');
      formData.append("task_status_id", values.status?.value || '0');
      formData.append("app_status", values.appStatus?.value || '0');
      formData.append("unit_id", authDetails?.unit_id);
      formData.append("create_by", authDetails?.user_id);
      formData.append("emp_id", authDetails?.empid);
      dispatch(fetchTimesheetReportList(formData))
    },
  });
  console.log("unitname>>>>>>>>>>>>>", authDetails)
  const columns = [
    { Header: "S.No", Cell: ({ row }) => reportList.length - row.index, className: "serial-no", applyHeaderClass: true },
    { Header: "Code", accessor: "emp_no" },
    { Header: "Name", accessor: "emp_name" },
    { Header: "Date", accessor: "t_date" },
    { Header: "Client", accessor: "client_name" },
    { Header: "Project", accessor: "project" },
    { Header: "Module", accessor: "module_name" },
    { Header: "Task", accessor: "task_name" },
    { Header: "Allocated Hours", accessor: "allocated_hours" },
    { Header: "Type", accessor: "task_type" },
    { Header: "Nature", accessor: "task_nature" },
    { Header: "Description", accessor: "task_description" },
    { Header: "Status", accessor: "task_status", },
    { Header: "App Status", accessor: "task_approval_status" },
    { Header: "Worked Hours", accessor: "worked_hours" },
    { Header: "Created By", accessor: "create_by" },
    { Header: "Created On", accessor: "created_dt" },
    { Header: "Approved Hours", accessor: "approved_hours" },
    { Header: "Billable Hours", accessor: "billable_hours" },
    { Header: "Non-Billable Hours", accessor: "nonbillable_hours" },
    { Header: "Approved By", accessor: "approved_by" },
    { Header: "Approved On", accessor: "approved_dt" },
    { Header: "Approved Remarks", accessor: "approved_remarks" },
    { Header: "Rejected By", accessor: "rejected_by" },
    { Header: "Rejected On", accessor: "rejected_dt" },
    { Header: "Rejected Reason", accessor: "rejected_reason" },
    { Header: "Cancelled By", accessor: "cancelled_by" },
    { Header: "Cancelled On", accessor: "cancelled_dt" },
    { Header: "Cancelled Reason", accessor: "cancelled_reason" },
  ];

  const data = [
    { sno: 1, code: "0012", name: "AES ADMIN", date: "30.04.25", client: "C0001 - ACV mills", project: "C0001 - ACV-P1 - Human resources management", module: "Employee management", task: "Flamingo HRMS new development", allocatedHours: "80:00", type: "Development", nature: "AMC", description: "test", status: "in-progress", appStatus: "Pending", workedHours: "08:00", createdBy: "AES ADMIN", createdOn: "30-04-2025 14:30", approvedHours: "00:00", approvedBy: "", approvedOn: "", approvedRemarks: "", rejectedBy: "", rejectedOn: "", rejectedReason: "", cancelledBy: "", cancelledOn: "", cancelledReason: "", },
    { sno: 2, code: "0014", name: "AES ADMIN", date: "30.04.25", client: "C0001 - ACV mills", project: "C0001 - ACV-P1 - Human resources management", module: "Employee management", task: "Flamingo HRMS new development", allocatedHours: "00:00", type: "Team meeting", nature: "AMC", description: "test", status: "in-progress", appStatus: "Approved", workedHours: "00:30", createdBy: "AES ADMIN", createdOn: "30-04-2025 14:31", approvedHours: "00:30", approvedBy: "AES ADMIN", approvedOn: "30-04-2025 14:33", approvedRemarks: "", rejectedBy: "", rejectedOn: "", rejectedReason: "", cancelledBy: "", cancelledOn: "", cancelledReason: "", },
    { sno: 3, code: "0018", name: "AES ADMIN", date: "02.05.25", client: "C0001 - ACV mills", project: "C0001 - ACV-P1 - Human resources management", module: "Employee management", task: "Flamingo HRMS new development", allocatedHours: "80:00", type: "Development", nature: "AMC", description: "sdfdfgdgdfdf", status: "in-progress", appStatus: "Approved", workedHours: "00:30", createdBy: "AES ADMIN", createdOn: "05-05-2025 10:33", approvedHours: "00:30", approvedBy: "AES ADMIN", approvedOn: "05-05-2025 10:33", approvedRemarks: "", rejectedBy: "", rejectedOn: "", rejectedReason: "", cancelledBy: "", cancelledOn: "", cancelledReason: "", },
    { sno: 4, code: "1010", name: "JOHN DOE", date: "01.05.25", client: "C0002 - XYZ corp", project: "C0002 - XYZ-P2 - Finance Management", module: "Payroll", task: "Salary processing", allocatedHours: "40:00", type: "Development", nature: "AMC", description: "Initial phase", status: "Completed", appStatus: "Approved", workedHours: "04:00", createdBy: "JOHN", createdOn: "01-05-2025 10:00", approvedHours: "04:00", approvedBy: "MANAGER", approvedOn: "01-05-2025 12:00", approvedRemarks: "Good work", rejectedBy: "", rejectedOn: "", rejectedReason: "", cancelledBy: "", cancelledOn: "", cancelledReason: "", },
    { sno: 5, code: "2002", name: "JANE SMITH", date: "03.05.25", client: "C0003 - DEF Ltd", project: "C0003 - DEF-P3 - Sales Management", module: "CRM", task: "Lead integration", allocatedHours: "35:00", type: "Testing", nature: "AMC", description: "Integration check", status: "Pending", appStatus: "Pending", workedHours: "02:00", createdBy: "JANE", createdOn: "03-05-2025 11:00", approvedHours: "00:00", approvedBy: "", approvedOn: "", approvedRemarks: "", rejectedBy: "", rejectedOn: "", rejectedReason: "", cancelledBy: "", cancelledOn: "", cancelledReason: "", },
  ];

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumbs title="Report" breadcrumbItem="Employee Daywise TimeSheet" />
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3">
                <Col lg={3} md={4}>
                  <Label>From Date <span className="text-danger">*</span></Label>
                  <CustomDatePicker
                    name="fromDate"
                    value={formik.values.fromDate}
                    onChange={(val) => formik.setFieldValue("fromDate", val)}
                    onBlur={() => formik.setFieldTouched("fromDate", true)}
                  />
                  {formik.touched.fromDate && formik.errors.fromDate && (
                    <div className="text-danger">{formik.errors.fromDate}</div>
                  )}
                </Col>
                <Col lg={3} md={4}>
                  <Label>To Date <span className="text-danger">*</span></Label>
                  <CustomDatePicker
                    name="toDate"
                    value={formik.values.toDate}
                    onChange={(val) => formik.setFieldValue("toDate", val)}
                    onBlur={() => formik.setFieldTouched("toDate", true)}
                  />
                  {formik.touched.toDate && formik.errors.toDate && (
                    <div className="text-danger">{formik.errors.toDate}</div>
                  )}
                </Col>
                <Col lg={3} md={4}>
                  <Label>Client</Label>
                  <CustomSelect
                    options={(client_list || []).map(option => ({ value: option.client_id.toString(), label: option.client_name }))}
                    name="client"
                    value={formik.values.client || null}
                    onChange={(selected) =>
                      formik.setFieldValue("client", selected)
                    }
                    isMulti
                  />
                </Col>
                <Col lg={3} md={4}>
                  <Label>Project</Label>
                  <CustomSelect
                    isMulti
                    options={(project_list || []).map(option => ({ value: option.project_id.toString(), label: option.project_name }))}
                    name="project"
                    value={formik.values.project || null}
                    onChange={(selected) =>
                      formik.setFieldValue("project", selected)
                    }
                  />
                </Col>
                <Col lg={3} md={4}>
                  <Label>Task Type</Label>
                  <CustomSelect
                    options={(time_tasktype || []).map(option => ({ value: option.tasktype_id.toString(), label: option.task_type }))}
                    name="taskType"
                    value={formik.values.taskType || null}
                    onChange={(selected) =>
                      formik.setFieldValue("taskType", selected)
                    }
                  />
                </Col>
                <Col lg={3} md={4}>
                  <Label>Task Nature</Label>
                  <CustomSelect
                    options={(time_tasknatures || []).map(option => ({ value: option.task_nature_id.toString(), label: option.task_nature }))}
                    name="taskNature"
                    value={formik.values.taskNature || null}
                    onChange={(selected) =>
                      formik.setFieldValue("taskNature", selected)
                    }
                  />
                </Col>
                <Col lg={3} md={4}>
                  <Label>Status</Label>
                  <CustomSelect
                    options={(time_taskstatus || []).map(option => ({ value: option.status_id.toString(), label: option.status_name }))}
                    name="status"
                    value={formik.values.status || null}
                    onChange={(selected) =>
                      formik.setFieldValue("status", selected)
                    }
                  />
                </Col>
                <Col lg={3} md={4}>
                  <Label>App Status</Label>
                  <CustomSelect
                    options={(appStatus_list || []).map(option => ({ value: option.appstatus_id.toString(), label: option.appstatus_name }))}
                    name="appStatus"
                    value={formik.values.appStatus || null}
                    onChange={(selected) =>
                      formik.setFieldValue("appStatus", selected)
                    }
                  />
                </Col>
                <Col md={12} className="d-flex justify-content-end">
                  <Button type="submit" className="btn button-search me-2">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                  <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                    <DropdownToggle color="primary" className="btn button-export me-2">
                      <i className="fas fa-file-export me-1" /> Export
                    </DropdownToggle>

                    <DropdownMenu>
                      <DropdownItem onClick={() => exportEmployeeToExcel(reportList.length > 0 ? reportList : data, authDetails?.unit_fullname, authDetails?.unit_address, "Emp Daywise TimeSheet")}>
                        <i className="fas fa-file-excel me-2 text-success" /> Export to Excel
                      </DropdownItem>

                      <DropdownItem onClick={() => exportEmployeeToPDF(reportList.length > 0 ? reportList : data, authDetails?.unit_fullname || "Company Name", { address: authDetails?.unit_address || "Company Address" }, "Emp Daywise TimeSheet", columns)}>
                        <i className="fas fa-file-pdf me-2 text-danger" /> Export to PDF
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                  <Button type="reset" onClick={formik.handleReset} className="btn button-cancel">
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <div className="timesheet-table">
              <TableContainer columns={columns} data={reportList} isGlobalFilter={true} customPageSize={10} />
            </div>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default TimesheetReportEmployeeDayWise;
